<template>
    <div class="select-box">
        <el-button type="text" @click="selectShow = true">{{text}}</el-button>

        <!--选择门店-->
        <SelectTree :tree-data="storeList" :checked-arr="selectedData" label-name="store_name" v-model="selectShow"
                    @checked="checkedEvent" />
    </div>
</template>

<script>
    import PopForm from "@/model/PopForm";
    import SelectTree from "@/model/SelectTree";
    export default {
        name: "ChainCheckStore",
        components: {SelectTree, PopForm},
        model:{
            prop: "selected",
            event: "selectChange"
        },
        props:{
            selected: {
                type: [Array, String],
                default: ""
            },
            placeholder: {
                type: String,
                default: "点击选择"
            }
        },
        data(){
            return {
                text: "",

                selectShow: false,
                storeList: [],
                selectedData: [],
            };
        },
        mounted(){
            this.init();
        },
        methods:{
            init(){
                this.textChange();
                this.loadStoreList();
            },
            textChange(){
                if(!this.selected || this.selected.length === 0) this.text = this.placeholder;
                else{
                    this.text = "已选择"+this.selected.length+"个门店";
                }
            },
            loadStoreList(){
                this.$root.postData("chain/get_child_store_list_short", {}, res => {
                    if(res.errcode === 0){
                        let storeArr = [];
                        res.data.forEach(val => {
                            if(val.is_main !== "1") storeArr.push(val);
                        });
                        this.storeList = storeArr;
                    }else{
                        this.$root.error(res.errdesc);
                    }
                });
            },
            checkedEvent(data){
                this.$emit("selectChange", data);
            }
        },
        watch: {
            selected(val){
                this.textChange();
                this.selectedData = val;
            }
        }
    }
</script>

<style scoped>

</style>
